import { CombinedGraphQLErrors } from '@apollo/client/errors';

/** The operation the access gate and header nav share. Kept in step with `useUserPermissions` by a test. */
export const PERMISSIONS_OPERATION_NAME = 'UserPermissions';

const NOT_AUTHORISED_MESSAGE = 'Not Authorised!';

/**
 * Whether an Apollo error is an authentication/authorisation failure.
 *
 * Today the API throws `extensions` away and answers every auth failure with
 * `{ message: 'Not Authorised!', statusCode: 401 }`, so UNAUTHENTICATED and
 * FORBIDDEN are indistinguishable on the wire. The `extensions.code` branch
 * is for when the backend keeps them.
 */
export function isNotAuthorisedError(error: unknown): boolean {
    if (!CombinedGraphQLErrors.is(error)) {
        return false;
    }

    return error.errors.some((entry) => {
        if (entry.message === NOT_AUTHORISED_MESSAGE) {
            return true;
        }
        if ('statusCode' in entry && entry.statusCode === 401) {
            return true;
        }
        const code = entry.extensions?.code;
        return code === 'UNAUTHENTICATED' || code === 'FORBIDDEN';
    });
}
